<script setup lang="ts">
import Logo from '@/components/Logo.vue'
</script>

<template>
  <div class="app-loading-screen">
    <div class="app-loading-content">
      <Logo class="app-loading-logo" />
      <div class="app-loading-rows">
        <div class="shimmer" style="width: 100%"></div>
        <div class="shimmer" style="width: 85%"></div>
        <div class="shimmer" style="width: 70%; animation-delay: 0.2s"></div>
        <div class="shimmer" style="width: 90%; animation-delay: 0.15s"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.app-loading-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: #f8f8f8;
}

.app-loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  width: 320px;
}

.app-loading-logo {
  height: 32px;
}

.app-loading-rows {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.shimmer {
  height: 16px;
  border-radius: 4px;
  background: linear-gradient(90deg, #e8e8e8 25%, #f0f0f0 50%, #e8e8e8 75%);
  background-size: 400% 100%;
  animation: shimmer 1.4s ease infinite;
}

.shimmer:nth-child(2) {
  animation-delay: 0.1s;
}

@keyframes shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
</style>
